module.exports = __webpack_public_path__ + "static/media/saideep-exports.9bf5f2d8.png";